const videoWrapper = document.querySelector('.header-homepage__video-wrapper');
const video = document.querySelector('.header-homepage__video');

if (videoWrapper) {
    video.addEventListener('playing', () => {
        video.classList.add('active');
    });
}
